import { hotelStaffReducerState } from "./hotelStaffTypes";
import { hotelStaffActionTypes } from "./hotelStaffTypes";

// conversationReducer.ts

const initialState: hotelStaffReducerState = {
    staff: null,
    // booked_rooms: [],
    loading: false,
    error: null,
};

const hotelStaffReducer = (state = initialState, action: any): hotelStaffReducerState => {
    switch (action.type) {
        case hotelStaffActionTypes.API_RESPONSE_SUCCESS:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_SUCCESS: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_SUCCESS. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case hotelStaffActionTypes.INSERT_HOTEL_STAFF:
                    console.log("[hotelReducer.ts] INSERT_HOTEL_STAFF success case triggred", action.payload);

                    return {
                        ...state,
                        // hotel: action.payload.data.insert_hotel,

                        loading: false

                    };

                case hotelStaffActionTypes.GET_ALL_STAFF:
                    console.log("[hotelReducer.ts] GET_ALL_STAFF success case triggred", action.payload);

                    return {
                        ...state,
                        staff: action.payload.data.all_staff,

                        loading: false

                    };

                case hotelStaffActionTypes.DELETE_STAFF:
                    console.log("[hotelReducer.ts] DELETE_STAFF success case triggred", action.payload);

                    return {
                        ...state,
                        // staff: action.payload.data.all_staff,

                        loading: false

                    };





                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }

        case hotelStaffActionTypes.API_RESPONSE_ERROR:
            if (!action.payload?.actionType) {
                console.error(
                    `API_RESPONSE_ERROR: Missing actionType in payload. Action type: ${action.type}, Payload:`, action.payload
                );
                throw new Error(
                    `Reducer error: Missing actionType in payload for API_RESPONSE_ERROR. Action: ${JSON.stringify(action)}`
                );
            }

            switch (action.payload.actionType) {

                case hotelStaffActionTypes.INSERT_HOTEL_STAFF:
                    console.log("[hotelReducer.ts] INSERT_HOTEL_STAFF errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case hotelStaffActionTypes.GET_ALL_STAFF:
                    console.log("[hotelReducer.ts] GET_ALL_STAFF errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"
                        // intent: null,
                        // uiComponent: null,
                        // agentLogId: null,
                        // missingFields: null
                        // isRoomListLoading: true,
                        // errorMessage: "",
                    };


                case hotelStaffActionTypes.DELETE_STAFF:
                    console.log("[hotelReducer.ts] DELETE_STAFF errror case triggred", action.payload);

                    return {
                        ...state,
                        // approvalSuccess: false,
                        loading: false,
                        error: "Apologies! Something went wrong"

                    };


                // Cases to be inserted later
                default:
                    return {
                        ...state,
                    };
            }



        case hotelStaffActionTypes.INSERT_HOTEL_STAFF:
            console.log("[hotelReducer.ts] INSERT_HOTEL_STAFF pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case hotelStaffActionTypes.GET_ALL_STAFF:
            console.log("[hotelReducer.ts] GET_ALL_STAFF pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };

        case hotelStaffActionTypes.DELETE_STAFF:
            console.log("[hotelReducer.ts] DELETE_STAFF pre api case triggred", action.payload);

            return {
                ...state,

                loading: true,
                error: null
                // userUtterance: action.payload.transcript
                // isRoomListLoading: true,
                // errorMessage: "",
            };


        // pre api cases
        default:
            return state;
    }
};


export default hotelStaffReducer;
